import BaseProduct from './BaseProduct';
import { ProductId } from '../types';
import store, { getLayerOpacity } from '../state';
import { getTileUrl, getModelCoordinates } from '../config';
import ManifestTimelineHelper from '../services/ManifestTimelineHelper';

export class SunriseLayer extends BaseProduct {
  public readonly id: ProductId = 'sunrise';

  private unsubscribeStore: (() => void) | null = null;
  private lastModel: string = '';

  protected onActivate(): void {
    this.refresh();
    this.unsubscribeStore = store.subscribe((s) => {
      if (!this.active) return;
      const currentModel = s.selectedModels[this.id] || 'gw_v2_blend_50';
      if (currentModel !== this.lastModel) {
        this.lastModel = currentModel;
        this.refresh();
      }
    });
  }

  protected onDeactivate(): void {
    if (this.unsubscribeStore) {
      this.unsubscribeStore();
      this.unsubscribeStore = null;
    }
    this.layerManager.removeBufferedRasterLayer(this.id);
    this.lastModel = '';
  }

  protected onTimeUpdate(_date: string, _hour: string): void {
    this.refresh();
  }

  public refresh(targetTimeMs?: number) {
    if (!this.active) return;
    const state = store.getState();
    const manifest = state.manifest;
    if (!manifest) return;

    const model = state.selectedModels[this.id] || 'gw_v2_blend_50';
    const opacity = getLayerOpacity(this.id, 1.0);

    const rawTime = targetTimeMs !== undefined ? new Date(targetTimeMs) : state.currentTimeStep;
    if (!rawTime) return;

    let dateStr: string;
    let event: string;

    if (state.webcamsEnabled && state.selectedWebcamDate) {
      dateStr = state.selectedWebcamDate;
      const tz = state.userTimezone || 'America/Los_Angeles';
      let isMorning = true;
      try {
        const dFmt = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: 'numeric', hour12: false });
        const localHour = parseInt(dFmt.format(rawTime), 10);
        isMorning = (localHour === 24 ? 0 : localHour) < 12;
      } catch {
        isMorning = rawTime.getUTCHours() < 12;
      }
      event = isMorning ? 'sunrise' : 'sunset';
    } else {
      const clampedFrame = ManifestTimelineHelper.getClampedFrame(manifest, 'sunrise', model, rawTime)
        || ManifestTimelineHelper.getClampedFrame(manifest, 'sunrise', 'gw_v2_blend_50', rawTime);
      dateStr = clampedFrame ? clampedFrame.dateStr : rawTime.toISOString().split('T')[0];
      event = clampedFrame ? clampedFrame.hourStr : 'sunrise';
    }

    const currentModel = model;
    const tiles = [
      getTileUrl(manifest, this.id, currentModel, dateStr, event)
    ];

    this.layerManager.updateBufferedRasterLayer(this.id, tiles, opacity, undefined, 0, 5, 'linear', getModelCoordinates(manifest, this.id, currentModel));
  }
}
export default SunriseLayer;
